import { useState } from "react";
import { Button, IconButton, Drawer, List, ListItem, ListItemText } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import Samriddhi from "../components/SamriddhiIcon.jpg";

export default function Header() {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const navLinks = [
        { label: "Home", to: "/" },
        { label: "About", to: "/About" },
        { label: "Programs", to: "/Programs" },
        { label: "Contact", to: "/Contact" }
    ];

    return (
        <header
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 24px",
                borderBottom: "1px solid #e0e0e0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                fontFamily: "'Segoe UI', 'Roboto', 'Arial', sans-serif"
            }}
        >
            {/* Logo + Title */}
            <Link
                to="/"
                style={{
                    textDecoration: "none",
                    color: "#000",
                    fontWeight: "bold",
                    alignItems: "center",
                    display: "flex",
                    fontSize: 20
                }}
            >
                <img
                    src={Samriddhi}
                    alt="Samriddhi Logo"
                    style={{
                        width: 40,
                        height: 40,
                        marginRight: 12,
                        borderRadius: "50%",
                        border: "2px solid black",
                        backgroundColor: "#000"
                    }}
                />
                Samriddhi Trust.
            </Link>

            {/* Desktop Navigation */}
            <nav
                className="nav-links"
                style={{
                    display: "flex",
                    gap: 12
                }}
            >
                <div
                    className="nav-desktop"
                    style={{
                        display: window.innerWidth >= 900 ? "flex" : "none",
                        gap: 12
                    }}
                >
                    {navLinks.map(({ label, to }) => (
                        <Button
                            key={label}
                            component={Link}
                            to={to}
                            style={{
                                color: "black",
                                background: "#fff",
                                borderRadius: 20,
                                fontWeight: 600,
                                padding: "6px 18px",
                                fontSize: 14,
                                border: "2px solid black"
                            }}
                            sx={{
                                "&:hover": {
                                    background: "#6366f1",
                                    color: "#fff"
                                }
                            }}
                        >
                            {label}
                        </Button>
                    ))}
                </div>

            {/* Mobile Hamburger */}
            <IconButton
                className="menu-button"
                edge="end"
                onClick={() => setDrawerOpen(true)}
                sx={{ display: { xs: "block", md: "none" }, color: "black" }}
            >
                <MenuIcon />
            </IconButton>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{ display: { xs: "block", md: "none" } }}
            >
                <List sx={{ width: 220 }}>
                    {navLinks.map(({ label, to }) => (
                        <ListItem
                            button
                            key={label}
                            component={Link}
                            to={to}
                            onClick={() => setDrawerOpen(false)}
                            sx={{ cursor: "pointer" }}
                        >
                            <ListItemText primary={label} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </nav>
        </header>
    );
}
